'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _equals = require('ramda/src/equals');

var _equals2 = _interopRequireDefault(_equals);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mapShapePropsByDiff = require('../../utils/mapShapePropsByDiff');

var _mapShapePropsByDiff2 = _interopRequireDefault(_mapShapePropsByDiff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ref: https://codepen.io/techniq/pen/yVEeOx

const ELEC_SIZE = 35; // 35 x 35

// https://silentmatt.com/rectangle-intersection/
var checkIntersect = function checkIntersect(A, box, tagName, elem) {
  if (tagName === 'text') return false;
  if (A && box) {
    const leftA = A.left; const rightBox = (box.x + box.width);
    const rightA = A.left + A.width; const leftBox = box.x;
    const topA = A.top; const bottomBox = (box.y + box.height);
    const bottomA = A.top + A.height; const topBox = box.y;
    if (!(leftA < rightBox && rightA > leftBox && topA < bottomBox && bottomA > topBox)) return false;

    // from hereon, know we at least intersect with the elem
    if (tagName === 'path') {
      // have to handle this case b/c combined electrode could be non-rectangular
      // like U-shaped -- but path objects are overall rectangular no matter what
      // so check if box border points (tested at every ELEC_SIZE offset) are ever
      // in the filled part of the combined electrode

      // but first see if selection box completely overlaps A
      // (and box's borders doesn't intersect w/ A's borders)
      if (leftBox <= leftA && topBox <= topA && rightBox >= rightA && bottomBox >= bottomA)
        return true;

      let x = leftBox;
      let y = topBox;
      const pt = elem.component.parentNode.createSVGPoint();
      // top border -- topleft to topright
      while (x <= rightBox) {
        pt.x = x;
        pt.y = y;
        if (elem.component.isPointInFill(pt)) return true;
        x += ELEC_SIZE;
      }

      // right border -- topright to bottomright
      x = rightBox;
      y = topBox;
      while (y <= bottomBox) {
        pt.x = x;
        pt.y = y;
        if (elem.component.isPointInFill(pt)) return true;
        y += ELEC_SIZE;
      }

      // bottom border -- bottomright to bottomleft
      x = rightBox;
      y = bottomBox;
      while (x >= leftBox) {
        pt.x = x;
        pt.y = y;
        if (elem.component.isPointInFill(pt)) return true;
        x -= ELEC_SIZE;
      }

      // left border -- bottomleft to topleft
      x = leftBox;
      y = bottomBox;
      while (y >= topBox) {
        pt.x = x;
        pt.y = y;
        if (elem.component.isPointInFill(pt)) return true;
        y -= ELEC_SIZE;
      }
    } else return true;
  }
  return false;
};

var ShapeItem = function (_React$PureComponent) {
  _inherits(ShapeItem, _React$PureComponent);

  function ShapeItem(props) {
    _classCallCheck(this, ShapeItem);

    var _this = _possibleConstructorReturn(this, (ShapeItem.__proto__ || Object.getPrototypeOf(ShapeItem)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = { isIntersect: false };
    return _this;
  }

  _createClass(ShapeItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          box = _props.box,
          onPositionChange = _props.onPositionChange,
          onIntersectChange = _props.onIntersectChange,
          Component = _props.tagName,
          isMovable = _props.isMovable,
          style = _props.style,
          mode = _props.mode,
          otherProps = _objectWithoutProperties(_props, ['box', 'onPositionChange', 'onIntersectChange', 'tagName', 'isMovable', 'style']);

      var onMouseDown = this.onMouseDown,
          onRef = this.onRef;
      var isIntersect = this.state.isIntersect;

      return _react2.default.createElement(Component, Object.assign({
        ref: onRef,
        style: _extends({}, style, {
          userSelect: 'none'
        }),
        onMouseDown: isMovable ? onMouseDown : null
      }, otherProps));
    }
  }]);

  return ShapeItem;
}(_react2.default.PureComponent);

ShapeItem.propTypes = {
  tagName: _propTypes2.default.string.isRequired,
  id: _propTypes2.default.string.isRequired,
  isMovable: _propTypes2.default.bool.isRequired,
  onPositionChange: _propTypes2.default.func.isRequired,
  box: _propTypes2.default.shape({
    width: _propTypes2.default.number.isRequired,
    left: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    top: _propTypes2.default.number.isRequired
  }).isRequired,
  onIntersectChange: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.componentDidMount = function () {
    // TODO: WHY setTimeout? for Splunk
    setTimeout(function () {
      _this2.updatePosition();
      _this2.checkIntersect(_this2.props);
    }, 200);
    document.addEventListener('scroll', _this2.updatePosition);
  };

  this.componentWillReceiveProps = function (nextProps) {
    if (!(0, _equals2.default)(nextProps.box, _this2.props.box)) {
      _this2.checkIntersect(nextProps);
    }
  };

  this.onMouseDown = function (e) {
    _this2.x = e.pageX;
    _this2.y = e.pageY;
    document.addEventListener('mousemove', _this2.onMouseMove);
    document.addEventListener('mouseup', _this2.onMouseUp);
  };

  this.onMouseMove = function (e) {
    // Diff calculate
    var xDiff = e.pageX - _this2.x;
    var yDiff = e.pageY - _this2.y;

    // Move
    _this2.props.onPositionChange(_extends({
      id: _this2.props.id
    }, (0, _mapShapePropsByDiff2.default)(_this2.props, { x: xDiff, y: yDiff })));

    // next
    _this2.x = e.pageX;
    _this2.y = e.pageY;
  };

  this.onMouseUp = function () {
    _this2.x = null;
    _this2.y = null;
    document.removeEventListener('mousemove', _this2.onMouseMove);
    document.removeEventListener('mouseup', _this2.onMouseUp);
    _this2.updatePosition();
  };

  this.onRef = function (ref) {
    if (!ref) _this2.component = document.getElementById(_this2.props.id);
    else _this2.component = ref;
  };

  this.componentWillUnMount = function () {
    document.removeEventListener('scroll', _this2.updatePosition);
  };

  this.getPathClientRect = function() {
    const boundingRect = _this2.component.getBoundingClientRect();
    const scale = parseFloat(_this2.component.getAttribute("scale"));
    const alertBottom = document.getElementById("topbar-buffer").getBoundingClientRect().bottom;
    let leftBoi, topBoi;

    if (_this2.component.getAttribute("mode") === "PIN") {
      leftBoi = (boundingRect.x - parseFloat(_this2.component.getAttribute("svgx")) - 214) / scale;
      topBoi = (boundingRect.y - parseFloat(_this2.component.getAttribute("svgy")) - 295 - alertBottom) / scale;
    } else {
      leftBoi = (boundingRect.x - parseFloat(_this2.component.getAttribute("svgx")) - 49) / scale;
      topBoi = (boundingRect.y - parseFloat(_this2.component.getAttribute("svgy")) - alertBottom) / scale;
    }
    return { leftBoi, topBoi, boundingRect, scale };
  };

  this.updatePosition = function () {
    if (_this2.component) {
      if (_this2.component.nodeName === "path") {
        const { leftBoi, topBoi, boundingRect, scale } = _this2.getPathClientRect();
        _this2.clientRect = {
          left: leftBoi,
          top: topBoi,
          width: boundingRect.width / scale,
          height: boundingRect.height / scale,
        };
      } else {
        _this2.clientRect = {
          left: parseInt(_this2.component.getAttribute("x")),
          top: parseInt(_this2.component.getAttribute("y")),
          width: parseInt(_this2.component.getAttribute("width")),
          height: parseInt(_this2.component.getAttribute("height")),
        };
      }
    }
  };

  this.checkIntersect = function (props) {
    if (!_this2.clientRect) {
      if (_this2.component.nodeName === "path") {
        const { leftBoi, topBoi, boundingRect, scale } = _this2.getPathClientRect();
        _this2.clientRect = {
          left: leftBoi,
          top: topBoi,
          width: boundingRect.width / scale,
          height: boundingRect.height / scale,
        };
      } else {
        _this2.clientRect = {
          left: parseInt(_this2.component.getAttribute("x")),
          top: parseInt(_this2.component.getAttribute("y")),
          width: parseInt(_this2.component.getAttribute("width")),
          height: parseInt(_this2.component.getAttribute("height")),
        };
      }
    }
    var isIntersect = checkIntersect(_this2.clientRect, props.box, _this2.props.tagName, _this2);
    _this2.setState({ isIntersect: isIntersect });
    _this2.props.onIntersectChange({ id: props.id, isIntersect: isIntersect });
  };
};

exports.default = ShapeItem;
module.exports = exports['default'];